import React from 'react'
import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

const formatWatchTime = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  return `${hours < 10 ? '0' : ''}${hours}:${
    minutes < 10 ? '0' : ''
  }${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
}

const MinMinuteModal = ({
  isOpen,
  onClose,
  duration,
}: {
  isOpen: boolean
  onClose: () => void
  duration: number
}) => {
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered size={'sm'}>
        <ModalOverlay />
        <ModalContent marginLeft={5} marginRight={5} borderRadius={'2xl'}>
          <ModalCloseButton
            color={'lyk-black'}
            opacity={0.7}
            fontSize={18}
            fontWeight={900}
            marginRight={3}
            marginTop={3}
          />
          <ModalBody className="mt-10 flex flex-col items-center justify-center">
            <Image src={'/rewards/exclamatory.svg'} alt="Icon" boxSize={12} />
            <Text
              className="my-2 text-center font-semibold text-black"
              fontSize={20}
            >
               Videos under 3 minutes are not eligible for monetization.
            </Text>
            <Text
              className="mt-3 text-center font-medium text-[#ED837F]"
              fontSize={16}
            >
              Video duration: {formatWatchTime(duration)}
            </Text>
          </ModalBody>

          <ModalFooter className="mb-4 mt-1 w-full self-center">
            <Button
              px={10}
              bg="lyk-green"
              textDecoration={'none'}
              color="white"
              width={'full'}
              _hover={{ opacity: 0.7 }}
              size={['md', 'md', 'md']}
              fontWeight={500}
              onClick={onClose}
            >
              Got it!
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

export default MinMinuteModal
